import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import { Link } from 'react-router-dom';
import { AuthUserContext } from '../Session';
import * as ROUTES from 'constants/routes';
import * as ROLES from 'constants/roles';
import SignOutButton from 'components/SignOut';

const NavBarNonAuth = () => {
    return (
        <div>
            <AppBar variant='persistent' className='AppBar' style={{ background: '#FAFAFA' }}>
                <Toolbar>
                    <Typography variant='h4' color='inherit' style={{marginLeft: '10px', flex: 1}}>
                        <Link to={ROUTES.LANDING} style={{color: '#666666', textDecoration: 'none'}}>SmplAgTech</Link>
                    </Typography>
                    <Button color='inherit'>
                        <Link to={ROUTES.LANDING} style={{color: '#666666', textDecoration: 'none'}}>Landing</Link>
                    </Button>
                    <Button color='inherit'>
                        <Link to={ROUTES.ABOUT_US} style={{color: '#666666', textDecoration: 'none'}}>About</Link>
                    </Button>
                    <Button color='inherit'>
                        <Link to={ROUTES.PRODUCT_PAGE} style={{color: '#666666', textDecoration: 'none'}}>Product Page</Link>
                    </Button>
                    <Button style={{backgroundColor: '#4CAF50'}}>
                        <Link to={ROUTES.SIGN_IN} style={{color: '#FAFAFA', textDecoration: 'none'}}>Log in</Link>
                    </Button>
                </Toolbar>
            </AppBar>
        </div>
    );
}

export default NavBarNonAuth;